export enum StripePaymentActionTypes {
  EXECUTING_STRIPE_ORDER = 'payment/EXECUTING_STRIPE_ORDER',
  STRIPE_ORDER_EXECUTED = 'payment/STRIPE_ORDER_EXECUTED',
}
